import { ErrorInfo, PureComponent, ReactNode } from 'react';

type ErrorBoundaryProps = {
  fallback: ReactNode;
  onError: (error: Error, errorInfo: ErrorInfo) => void;
};

type ErrorBoundaryState = {
  error: Error | null;
};

export class ErrorBoundary extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { onError } = this.props;
    try {
      onError(error, errorInfo);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Could not report error', err);
    }
  }

  render() {
    const { error } = this.state;
    const { fallback: Fallback, children } = this.props;

    if (error) {
      return Fallback;
    }

    return children;
  }
}
